// Use Case Constants
export const USE_CASE_TWO_FACTOR_AUTHENTICATION = 'TWO_FACTOR_AUTHENTICATION'
export const USE_CASE_ACCOUNT_NOTIFICATIONS = 'ACCOUNT_NOTIFICATIONS'
export const USE_CASE_CUSTOMER_CARE = 'CUSTOMER_CARE'
export const USE_CASE_CHARITY_NONPROFIT = 'CHARITY_NONPROFIT'
export const USE_CASE_DELIVERY_NOTIFICATIONS = 'DELIVERY_NOTIFICATIONS'
export const USE_CASE_FRAUD_ALERT_MESSAGING = 'FRAUD_ALERT_MESSAGING'
export const USE_CASE_EVENTS = 'EVENTS'
export const USE_CASE_HIGHER_EDUCATION = 'HIGHER_EDUCATION'
export const USE_CASE_K12 = 'K12'
export const USE_CASE_MARKETING = 'MARKETING'
export const USE_CASE_POLLING_AND_VOTING_NON_POLITICAL = 'POLLING_AND_VOTING_NON_POLITICAL'
export const USE_CASE_POLITICAL_ELECTION_CAMPAIGNS = 'POLITICAL_ELECTION_CAMPAIGNS'
export const USE_CASE_PUBLIC_SERVICE_ANNOUNCEMENT = 'PUBLIC_SERVICE_ANNOUNCEMENT'
export const USE_CASE_SECURITY_ALERT = 'SECURITY_ALERT'

// Opt-in Type Constants
export const OPT_IN_TYPE_VERBAL = 'VERBAL'
export const OPT_IN_TYPE_WEB_FORM = 'WEB_FORM'
export const OPT_IN_TYPE_PAPER_FORM = 'PAPER_FORM'
export const OPT_IN_TYPE_VIA_TEXT = 'VIA_TEXT'
export const OPT_IN_TYPE_MOBILE_QR_CODE = 'MOBILE_QR_CODE'

// Use Case Options for UI
export const USE_CASE_OPTIONS = [
    { value: USE_CASE_TWO_FACTOR_AUTHENTICATION, label: 'Two-Factor Authentication' },
    { value: USE_CASE_ACCOUNT_NOTIFICATIONS, label: 'Account Notifications' },
    { value: USE_CASE_CUSTOMER_CARE, label: 'Customer Care' },
    { value: USE_CASE_CHARITY_NONPROFIT, label: 'Charity/Nonprofit' },
    { value: USE_CASE_DELIVERY_NOTIFICATIONS, label: 'Delivery Notifications' },
    { value: USE_CASE_FRAUD_ALERT_MESSAGING, label: 'Fraud Alert Messaging' },
    { value: USE_CASE_EVENTS, label: 'Events' },
    { value: USE_CASE_HIGHER_EDUCATION, label: 'Higher Education' },
    { value: USE_CASE_K12, label: 'K-12 Education' },
    { value: USE_CASE_MARKETING, label: 'Marketing' },
    { value: USE_CASE_POLLING_AND_VOTING_NON_POLITICAL, label: 'Polling and Voting (Non-Political)' },
    { value: USE_CASE_POLITICAL_ELECTION_CAMPAIGNS, label: 'Political/Election Campaigns' },
    { value: USE_CASE_PUBLIC_SERVICE_ANNOUNCEMENT, label: 'Public Service Announcement' },
    { value: USE_CASE_SECURITY_ALERT, label: 'Security Alert' },
]

// Opt-in Type Options for UI
export const OPT_IN_TYPE_OPTIONS = [
    { value: OPT_IN_TYPE_VERBAL, label: 'Verbal' },
    { value: OPT_IN_TYPE_WEB_FORM, label: 'Web Form' },
    { value: OPT_IN_TYPE_PAPER_FORM, label: 'Paper Form' },
    { value: OPT_IN_TYPE_VIA_TEXT, label: 'Via Text' },
    { value: OPT_IN_TYPE_MOBILE_QR_CODE, label: 'Mobile QR Code' },
]

// Volume Options for UI
export const VOLUME_VALUES = [
    '10',
    '100',
    '1,000',
    '10,000',
    '100,000',
    '250,000',
    '500,000',
    '750,000',
    '1,000,000',
    '5,000,000',
    '10,000,000+',
]

// Generate volume options with same value and label
export const VOLUME_OPTIONS = VOLUME_VALUES.map(value => ({ value, label: value }))
